export const TYPE_ETAT_CACHE = [
    { id: 0, description: 'Indetermine' },
    { id: 1, description: 'Nouvelle Cache' },
    { id: 2, description: 'Renouvellement' },
    { id: 3, description: 'Deplacement ' },
]

export const TYPE_STATUT_CACHE = [
    { id: 0, description: 'Cache' },
    { id: 1, description: 'Treestand ' }
]